<template>
  <CHeader position="sticky">
    <CContainer>
      <CImage :src="imgUrl" :height="100" />
      <CHeaderNav>
        <div class="user">
          <CIcon class="my-1 mx-2" icon="cil-user" size="lg" />
          <span class="username">{{ payload.userId }}</span>
        </div>
        <div class="caseNumber text-end">
          (Fallnummer: {{ payload.caseNumber }})
        </div>
        <div class="logout text-end pt-2">
          <CButton
            as="a"
            href="#/app/logout"
            color="danger"
            variant="outline"
            size="sm"
            >Logout</CButton
          >
        </div>
      </CHeaderNav>
    </CContainer>
  </CHeader>
</template>

<script>
import AuthService from '@/_services/auth.service'
import imgUrl from '@/assets/images/app-icon.png'

export default {
  name: 'Header',
  setup() {
    return {
      imgUrl,
      payload: '',
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn
    },
  },
  created() {
    if (this.loggedIn === true) {
      this.payload = AuthService.getPayload()
    }
  },
  watch: {
    columnFilter() {
      this.getUsers()
    },
    columnSorter: {
      handler() {
        this.getUsers()
      },
      deep: true,
    },
    message: {
      handler() {
        //alert('TEST')
      },
    },
  },
}
</script>
